export function useApiBase(): string {
  const config = useRuntimeConfig()
  return config.public.apiBase
}

/**
 * Ambil pesan error yang bisa dibaca manusia dari error $fetch.
 *
 * Isi `{"error": …}` dari server TIDAK lagi diteruskan mentah ke layar: ia
 * ditulis untuk developer dan membocorkan kosakata internal kami (job, sku,
 * session, billing). Penerjemahan dan aturan daftar putihnya ada di
 * `app/utils/galat.ts` — file itu murni, jadi bisa diuji tanpa Nuxt.
 */
export function pesanError(err: unknown, fallback = 'Terjadi kesalahan, coba lagi.'): string {
  return pesanRamah(err, fallback)
}
